import { forwardRef, type ReactNode } from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Tooltip, type ITooltipProps } from 'shared/ui'
import styles from './styles.module.scss'

type IWidgetItemProps = {
  isFocused?: boolean
  isDisabled?: boolean
  onClick?: () => void
  badgeIndex?: number
  leftNode?: ReactNode
  children: ReactNode
  rightNode?: ReactNode
  tooltipProps?: Partial<ITooltipProps>
  className?: string
}

export const WidgetItemRef = forwardRef<HTMLDivElement, IWidgetItemProps>(
  (
    {
      isFocused,
      isDisabled,
      onClick,
      badgeIndex,
      leftNode,
      children,
      rightNode,
      tooltipProps,
      className,
    },
    ref
  ) => {
    const item = (
      <div
        ref={ref}
        className={classnames(
          styles.item,
          isFocused && styles.itemFocused,
          isDisabled && styles.itemDisabled,
          className
        )}
        onClick={onClick}
      >
        {badgeIndex !== undefined ? (
          <span className={classnames(styles.badge, isFocused && styles.badgeFocused)}>
            {badgeIndex + 1}
          </span>
        ) : (
          leftNode
        )}
        <span className={styles.itemContent}>{children}</span>
        {rightNode && <span className={styles.itemRightNode}>{rightNode}</span>}
      </div>
    )

    return (
      <>
        {tooltipProps ? (
          <Tooltip fullWidth {...tooltipProps}>
            {item}
          </Tooltip>
        ) : (
          item
        )}
        <div className={styles.divider} />
      </>
    )
  }
)

WidgetItemRef.displayName = 'WidgetItemRef'

export const WidgetItem = observer(WidgetItemRef)
